import IPosition from "@/models/dto/position.dto"
import IDeviceStore from "@/models/modelStore/IDeviceStore"

export default class DeviceUtil {
    static addPositionRaster(device: IDeviceStore, position?: IPosition) {
        if (!device.positions) device.positions = []
        if (position) {
            device.position = position
            const lastPosition = device.positions[device.positions.length - 1]
            if ((lastPosition?.latitude !== position.latitude) || (lastPosition?.longitude !== position.longitude)) {
                device.positions.push({
                    latitude: position.latitude,
                    longitude: position.longitude
                })
            }
        }
        return device
    }

    static formatKnToKmh(speed?: number | string) {
        const speedIn = typeof speed === "string" ? Number(speed) : speed;
        return Number(((speedIn || 0) * Number(process.env.VUE_APP_SPEED_FACTOR_KN_TO_KMH)).toFixed(0))
    }

    static formatKmhToKn(speed?: number | string) {
        const speedIn = typeof speed === "string" ? Number(speed) : speed;
        return Number(((speedIn || 0) / Number(process.env.VUE_APP_SPEED_FACTOR_KN_TO_KMH)))
    }

    static formatOdometerFromReport(odometer?: number) {
        if (odometer) {
            return `${(odometer / 1000).toFixed(0)} Km`
        } else {
            return 'NaN Km'
        }
    }

    static formatBattery(power?: number) {
        return `${(power)?.toFixed(1) || 'NaN'} V`
    }
}